module.exports = __webpack_public_path__ + "img/1-2-p2.63a3875d.svg";